import { useEffect, useState } from "react";

// Loads Apple JS SDK once and returns readiness.
// Prevents "AppleID is not defined" by rendering AppleLogin only after SDK is available.
export default function useAppleJs() {
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    const w = window as any;
    if (w.AppleID) {
      setReady(true);
      return;
    }

    const scriptId = "appleid-js-sdk";
    const existing = document.getElementById(scriptId) as HTMLScriptElement | null;

    const onLoad = () => {
      setReady(!!(window as any).AppleID);
    };
    const onError = () => {
      setReady(false);
    };

    if (existing) {
      if (existing.getAttribute("data-loaded") === "true") {
        onLoad();
      } else {
        existing.addEventListener("load", onLoad, { once: true } as any);
        existing.addEventListener("error", onError, { once: true } as any);
      }
      return;
    }

    const s = document.createElement("script");
    s.id = scriptId;
    s.src =
      "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
    s.async = true;
    (s as any).defer = true;
    s.onload = () => {
      s.setAttribute("data-loaded", "true");
      onLoad();
    };
    s.onerror = onError;
    document.head.appendChild(s);

    return () => {
      // do not remove the script; keep it cached for other components
    };
  }, []);

  return ready;
}
